import { cn } from "@web/lib/utils"
import Comexx from "./assets/w-com-hash.webp"

type SealMaskProps = { serial: string; className?: string; publicHash: string }

export function SealMask({ serial, publicHash, className }: SealMaskProps) {
	return (
		<div className={cn("h-[300px] w-[300px] md:scale-100", className)}>
			<div
				className="h-full w-full bg-center bg-cover"
				style={{
					backgroundImage: `url(${Comexx})`,
				}}>
				<div className="h-full w-full relative">
					<div className="w-full max-w-[120px] h-[24px] absolute left-[90px] top-[214px] text-white rounded-sm bg-black/50">
						<p className="flex justify-center font-bold -mt-[3px] text-[20px] font-[Doto] text-white">{publicHash}</p>
					</div>

					<div className="w-full max-w-[150px] h-[28px] absolute left-[75px] top-[45px] text-white rounded-sm bg-black/50">
						<p className="flex justify-center -mt-[5px] text-[27px] font-bold font-[Doto] text-white">
							{`A${serial.split(".")[1]}.${serial.split(".")[2]}`}
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}
